import { Box } from "@mui/material";
import {
	ContainmentInfoCard,
	ContainmentTypeCard,
	SectorsAndPlantsCard,
	PartNumbersCard,
} from "pages/Upload/cards";
import {
	ContainmentTypeConfig,
	ShouldShowPartNumbersSummary,
} from "pages/Upload/hooks/containmentTypeConfig";

interface sectorDisplay {
	id: string;
	name: string;
}

interface plantDisplay {
	id: string;
	name: string;
	sectorId?: string;
}

interface containmentSummaryProps {
	name?: string;
	description?: string;
	mccId?: string;
	containmentTypeLabel?: string | null;
	typeConfig?: ContainmentTypeConfig;
	initialHoldName?: string | null;
	subsequentHoldName?: string | null;
	sectors?: sectorDisplay[];
	plants?: plantDisplay[];
	hasMultipleParts?: boolean;
	partNumber?: string;
	supplierDunsName?: string | null;
	uploadContentTypeLabel?: string | null;
	showSectorsAndPlants?: boolean;
	showPartNumbers?: boolean;
}

export function ContainmentSummary({
	name,
	description,
	mccId,
	containmentTypeLabel,
	typeConfig,
	initialHoldName,
	subsequentHoldName,
	sectors = [],
	plants = [],
	hasMultipleParts = false,
	partNumber,
	supplierDunsName,
	uploadContentTypeLabel,
	showSectorsAndPlants = true,
	showPartNumbers = true,
}: containmentSummaryProps): React.JSX.Element {
	return (
		<Box display="flex" flexDirection="column" gap={1.5}>
			<ContainmentInfoCard
				readonly
				mccId={mccId}
				name={name}
				description={description}
			/>

			<ContainmentTypeCard
				readonly
				containmentTypeLabel={containmentTypeLabel}
				typeConfig={typeConfig}
				initialHoldName={initialHoldName}
				subsequentHoldName={subsequentHoldName}
			/>

			{showSectorsAndPlants && (
				<SectorsAndPlantsCard
					readonly
					sectors={sectors}
					plants={plants}
				/>
			)}

			{showPartNumbers &&
				ShouldShowPartNumbersSummary({
					typeConfig,
					hasMultipleParts,
					partNumber,
					supplierDunsName,
					uploadContentTypeLabel,
				}) && (
				<PartNumbersCard
					readonly
					typeConfig={typeConfig}
					hasMultipleParts={hasMultipleParts}
					partNumber={partNumber}
					supplierDunsName={supplierDunsName}
					uploadContentTypeLabel={uploadContentTypeLabel}
				/>
			)}
		</Box>
	);
}
